
export default {
  name: "DeviceModal",
model: { prop: "modelValue", event: "update:modelValue" },
  props: {
    modelValue: Boolean,
    // eslint-disable-next-line vue/require-default-prop
    type: String,
  },

  emits: ["update:modelValue", "save"],

  data() {
    return {
      form: this.defaultForm(),

      makerOptions: {
        Sensor: ["Vion Vision", "TDI"],
        PoE: ["Netgear", "Cisco", "TP-Link"],
        Other: [],
      },

      modelOptions: {
        Sensor: ["G5", "G4", "G3"],
        PoE: ["8 Port", "16 Port", "24 Port"],
        Other: [],
      },
    };
  },

  computed: {
    makerList() {
      return this.makerOptions[this.type] || [];
    },
    modelList() {
      return this.modelOptions[this.type] || [];
    },
  },

  watch: {
    modelValue(open) {
      if (open) this.resetForm();
    },
  },

  methods: {
    defaultForm() {
      return {
        maker: "",
        model: "",
        serial: "",
        mac: "",
        orderDate: "",
        receivedDate: "",
        cost: "",
      };
    },

    resetForm() {
      this.form = this.defaultForm();
    },

    close() {
      this.$emit("update:modelValue", false);
    },

    handleSave(continueAdding) {
      this.$emit("save", {
        ...this.form,
        type: this.type,
        continueAdding,
      });

      continueAdding ? this.resetForm() : this.close();
    },
  },
};
